import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    EntityTypeClient,
    EntityTypeCounterDto,
    GetEntityCountersParameters,
    ReserveEntityOptionView,
    SearchMainEntitiesParameters,
    SearchMainEntitiesResultDto
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class EntityTypeService {
    constructor(private readonly client: EntityTypeClient) {}

    async searchMainEntities(body: SearchMainEntitiesParameters): Promise<SearchMainEntitiesResultDto[]> {
        return await lastValueFrom(this.client.entityTypeSearchMainEntities(body));
    }

    async getReservedOptions(): Promise<ReserveEntityOptionView[]> {
        return await lastValueFrom(this.client.entityTypeGetReserveOptions());
    }

    async getEntityCounters(body: GetEntityCountersParameters): Promise<EntityTypeCounterDto[]> {
        return await lastValueFrom(this.client.entityTypeGetEntityCounters(body));
    }
}
